export const BEACON_LIMIT = 99999

export const METERS_TO_METERS = 1
export const METERS_TO_YARDS = 1.09361
export const METERS_TO_FEET = 3.28084

export const SMALL_ROOM_ID = 1
export const MEDIUM_ROOM_ID = 2
export const LARGE_ROOM_ID = 3
export const OPEN_SPACE_ID = 4

export const METERS_ID = 1
export const FEET_ID = 2
export const YARDS_ID = 3

export const METERS_TEXT = 'meters'
export const FEET_TEXT = 'feet'
export const YARDS_TEXT = 'yards'

export const RANGE_STEP = 1
export const RANGE_MIN = 1
export const RANGE_MAX = 8

export const RANGE_1_INDEX = 1
export const RANGE_2_INDEX = 2
export const RANGE_3_INDEX = 3
export const RANGE_4_INDEX = 4
export const RANGE_5_INDEX = 5
export const RANGE_6_INDEX = 6
export const RANGE_7_INDEX = 7
export const RANGE_8_INDEX = 8

export const RANGE_DEFAULT = 1

export const RANGE_1_VALUE = 1
export const RANGE_2_VALUE = 3
export const RANGE_3_VALUE = 7
export const RANGE_4_VALUE = 15
export const RANGE_5_VALUE = 30
export const RANGE_6_VALUE = 40
export const RANGE_7_VALUE = 50
export const RANGE_8_VALUE = 70

export const rangeOfBeacon = {
  m: [1, 3, 7, 15, 30, 40, 50, 70],
  ft: [3, 10, 22, 50, 100, 130, 160, 230],
  yd: [1, 3, 8, 16, 33, 44, 55, 77],
}
